import React from 'react';

let DownloadablePDF = ({src})=>{
  return <div className='downloadabe-pdf-cntr' style={{height:'100%'}}>
    <object data={src} width='100%' height='100%'></object>
  </div>
}

export default DownloadablePDF;